export default __webpack_public_path__ + "static/media/folks-logo-with-title.8d3b1a5b.svg";